import React from 'react';
import './Hero.scss';
import videoLoopM from '../../../assets/intro/hero/hero_mobile.mp4';
import videoLoopD from '../../../assets/intro/hero/hero_desktop.mp4';
import logoLock from '../../../assets/intro/hero/logo-lockup.svg';
import ms from '../../../assets/intro/hero/logo-ms.png';

function Hero({ titleRef, logoLockRef, msRef, videoLoopRef, screenWidth }) {
  return (
    <section className="hero">
      <div className="hero__videoLoop">
        <video autoPlay muted playsInline className="hero__videoLoop__video" ref={videoLoopRef}>
          <source src={screenWidth > 480 ? videoLoopD : videoLoopM} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="hero__text">
        <div className="hero__logo">
          <img className="hero__logo-lock" src={logoLock} alt="Creating Space" ref={logoLockRef} />
          <img className="hero__logo-ms" src={ms} alt="By Morgan Stanley" ref={msRef} />
        </div>

        <h1 className="hero__title" ref={titleRef}>
          The Evolution of Inclusive Spacesuit Design
        </h1>
      </div>
    </section>
  );
}

export default Hero;
